import * as API from "@/API";

export const fetchComponents = async ({ commit }) => {
  const components = await API.fetchComponents();
  commit("UPDATE_COMPONENTS", components);
};



export const loadedFont = async ({ commit }, loadedFont) => {
  commit("LOAD_FONTS", loadedFont);
};

export const fetchTemplates = async ({ commit }) => {
  const templates = await API.fetchTemplates();
  commit("UPDATE_TEMPLATES", templates);
};

export const uploadFiles = async (ctx, { creativeId, userId, fileType, name, mimetype, assetId = "" , assetFolderId = null, accessId = null, groupId, brandKitId}) => {
  const data = await API.uploadFiles(creativeId, userId, fileType, name, mimetype, assetId, assetFolderId, accessId, groupId, brandKitId);
  return data;
};

export const uploadFont = async (ctx, fontFile) => {
  let data = await API.uploadFont(fontFile);
  return data;
};


export const uploadFilesMetaData = async (ctx, { assetId, width, height, size, name,  duration , accessId, assetFolderId, brandKitId }) => {
  await API.uploadFilesMetaData(assetId, width, height, size, name, duration, accessId, assetFolderId, brandKitId);
};

export const getFontName = async (ctx, { src }) => {
  const {data} = await API.getFontName(src);
  return data;
};

export const fetchTemplate = async (ctx, templateURI) => {
  const template = await API.fetchTemplateDefinition(templateURI);
  return template;
};

export const addFrame = ({ commit }, { frame, index }) => {
  commit("ADD_FRAME", { frame, index });
};

export const deleteFrame = ({ commit }, index) => {
  commit("DELETE_FRAME", index);
};

export const swapFrames = ({ commit }, { firstIndex, secondIndex }) => {
  commit("SWAP_FRAME", { firstIndex, secondIndex });
};

export const deleteEvent = ({ commit }, index) => {
  commit("DELETE_EVENT", index);
};

export const deleteEventId = ({ commit }, id) => {
  commit("DELETE_EVENT_ID", id);
};

export const deleteCustomMethod = ({ commit }, name) => {
  commit("DELETE_CUSTOM_METHOD", name);
};

export const setFrames = ({ commit }, frames) => {
  commit("SET_FRAMES", frames);
};
export const setEvents = ({ commit }, events) => {
  commit("SET_EVENTS", events);
};

export const setTags = ({ commit }, tags) => {
  commit("SET_TAGS", tags);
};

export const setIsDraftSaved = ({ commit }, isSaved) => {
  commit("SET_IS_DRAFT_SAVED", isSaved);
};

export const setTemplateCache = ({ commit }, data) => {
  commit("SET_TEMPLATE_CACHE", data);
};

export const setIsPreview = ({ commit }, isPreview) => {
  commit("SET_IS_PREVIEW", isPreview);
};

export const setThumbnailUrl = ({ commit }, url) => {
  commit("SET_THUMBNAIL_URL", url);
};

export const setCreativeName = ({ commit }, creativeName) => {
  commit("SET_CREATIVE_NAME", creativeName);
};

export const setCreativeId = ({ commit }, creativeId) => {
  commit("SET_CREATIVE_ID", creativeId);
};

export const setCreativeVersion = ({ commit }, index) => {
  commit("SET_CREATIVE_VERSION", index);
};

// update current frame
export const updateCurrentFrame = ({ commit }, currentFrame) => {
  commit("UPDATE_CURRENT_FRAME", currentFrame);
};
export const saveCreativeStatus = ({ commit }, show) => {
  commit("SAVE_CREATIVE_STATUS", show);
};
export const publishedPreviewId = ({ commit }, previewId) => {
  commit("PUBLISHED_PREVIEW_ID", previewId);
};
export const draftPreviewId = ({ commit }, previewId) => {
  commit("DRAFT_PREVIEW_ID", previewId);
};
export const draftUpdatedDate = ({ commit }, draftUpdated) => {
  commit("SAVE_DRAFT_UPDATED_DATE", draftUpdated);
};
export const updateFramePreview = (
  { commit },
  { frameId, src, state: frame }
) => {
  commit("UPDATE_FRAME_PREVIEW", { frameId, src, frame });
};

export const updateFrameName = ({ commit }, { frameId, name }) => {
  commit("UPDATE_FRAME_NAME", { frameId, name });
};

export const updateFrameSize = ({ commit }, { frameId, size }) => {
  commit("UPDATE_FRAME_SIZE", { frameId, size });
};

export const addAnimationTiming = ({ commit }, timing) => {
  commit("ADD_ANIMATION_TIMING", timing);
};

export const setAnimationTiming = ({ commit }, timings) => {
  commit("SET_ANIMATION_TIMING", timings);
};

export const addTrigger = ({ commit }, data) => {
  commit("ADD_TRIGGER", data);
};

export const editTrigger = ({ commit }, { trigger, pageId, index }) => {
  commit("EDIT_TRIGGER", { trigger, pageId, index });
};

export const addCustomMethod = ({ commit }, method) => {
  commit("ADD_CUSTOM_METHOD", method);
};

export const setOutline = ({ commit }, objects) => {
  commit("SET_OUTLINE", objects);
};

export const setComponentExitUrl = ({ commit }, index) => {
  commit("SET_COMPONENT_EXIT_URL", index);
};

export const login = async ({ dispatch }, { email, password }) => {
  try {
    const data = await API.login(email, password);
    if (data.error) {
      throw new Error(data.response);
    }
    await dispatch("getCurrentUser");
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const openCreative = async (
  context,
  {
    adType,
    creativeName,
    campaignName,
    campaignId,
    advertiserName,
    publisherName,
    templateId,
    isResponsive,
    height,
    width,
    expansionMode,
    insertionMode,
    expCanvasHeight,
    expCanvasWidth
  }
) => {
  try {
    const data = await API.openCreative(
      adType,
      campaignName,
      campaignId,
      advertiserName,
      publisherName,
      creativeName,
      templateId,
      height,
      width,
      isResponsive,
      expansionMode,
      insertionMode,
      expCanvasHeight,
      expCanvasWidth
    );
    if (data.error) {
      throw new Error(data.response);
    } else {
      return data.data;
    }
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const getCreativeAdTypes = async (
  context,
  withAll = false
) => {
  try {
    const data = await API.getCreativeAdTypes(withAll);
    if (data.error) {
      throw new Error(data.response);
    } else {
      return data.data;
    }
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const getInsertionTypes = async (
  context,
) => {
  try {
    const data = await API.getInsertionTypes();
    if (data.error) {
      throw new Error(data.response);
    } else {
      return data.data;
    }
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const createCampaign = async (
  context,
  {
    campaignName,
    advertiserName,
    publisherName
  }
) => {
  try {
    const data = await API.createCampaign(
      campaignName,
      advertiserName,
      publisherName
    );
    if (data.error) {
      throw new Error(data.response);
    } else {
      return data.data;
    }
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const updateCampaign = async (
  context,
  {
    campaignId,
    campaignName,
    advertiserName,
    publisherName
  }
) => {
  try {
    const data = await API.updateCampaign(
      campaignId,
      campaignName,
      advertiserName,
      publisherName
    );
    if (data.error) {
      throw new Error(data.response);
    } else {
      return data.data;
    }
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const deleteCampaign = async (context, campaignId) => {
  try {
    const data = await API.deleteCampaign(campaignId);
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const createUser = async (context, user) => {
  try {
    const data = await API.createUser(user);
    if (data.error) {
      throw new Error(data.response);
    }
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const getUsers = async (
  context,
  { page = 1, search = "", sort, order }
) => {
  try {
    const data = await API.getUsers(page, search, sort, order);
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const deleteUser = async (context, userId) => {
  try {
    const data = await API.deleteUser(userId);
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const getUser = async (context, id) => {
  try {
    const data = await API.getUser(id);
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const updateUser = async (context, user) => {
  try {
    const { id } = user;
    if (!id) {
      throw {
        message: "Validation Error",
        details: ["User ID is required"],
      };
    }

    const data = await API.updateUser(id, user);
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const getUserRoles = async (context, page = 1) => {
  try {
    const data = await API.getUserRoles(page);
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const generatePassword = async (context) => {
  try {
    const data = await API.generatePassword();
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const getCurrentUser = async ({ commit }) => {
  try {
    const data = await API.getCurrentUser();
    if (data.error) {
      throw new Error(data.response);
    }
    commit("SET_CURRENT_CONTEXT", data.data);
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const getAdvertiserList = async (context, search) => {
  try {
    const data = await API.getAdvertiserList(search);

    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const getCampaignList = async (context, search) => {
  try {
    const data = await API.getCampaignList(search);

    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const getPublisherList = async (context, search) => {
  try {
    const data = await API.getPublisherList(search);

    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};
export const getCreativesList = async (
  { commit },
  { page = 1, campaignId = 0, search }
) => {
  try {
    const data = await API.getCreativesList(page, campaignId, search);
    if (data.error) {
      throw new Error(data.response);
    }
    commit("SET_CREATIVES_LIST", data.data.data);
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};
export const getPlacementsList = async (context, creativeid) => {
  try {
    const data = await API.getPlacementsList(creativeid);
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};
export const createPlacement = async (
  context,
  { name, creativeId, adType,  trackers }
) => {
  try {
    if (!name) {
      throw {
        message: "Validation Error",
        details: ["Placement name is required"],
      };
    }
    const data = await API.createPlacement(name, creativeId, adType, trackers );
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};
export const deletePlacement = async (context, placementId) => {
  try {
    const data = await API.deletePlacement(placementId);
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};
export const getPlacementTag = async (context, placementId) => {
  try {
    const data = await API.getPlacementTag(placementId);
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};
export const updateUserProfile = async (
  { dispatch },
  { firstName, lastName, designation, phone, email, timezone, profileImage }
) => {
  try {
    if (!firstName) {
      throw {
        message: "Validation Error",
        details: ["First name is required"],
      };
    }
    if (!lastName) {
      throw {
        message: "Validation Error",
        details: ["Last name is required"],
      };
    }
    if (!email) {
      throw {
        message: "Validation Error",
        details: ["Email is required"],
      };
    }
    const data = await API.updateUserProfile(
      firstName,
      lastName,
      designation,
      phone,
      email,
      timezone,
      profileImage
    );
    if (data.error) {
      throw new Error(data.response);
    }
    await dispatch("getCurrentUser");
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};
export const getCampaigns = async (
  context,
  { sort, order, page = 1, search }
) => {
  try {
    const data = await API.getCampaigns(sort, order, page, search);
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};
export const getCampaignById = async (context, id) => {
  try {
    const data = await API.getCampaignById(id);
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};
export const logout = async ({ commit }) => {
  try {
    const { unsubscribeNotificationChannel } = await import(
      "@/realtime/notificationsChannel"
    );
    const { disconnectEcho } = await import("@/realtime/echo");
    unsubscribeNotificationChannel();
    disconnectEcho();

    const data = await API.logout();
    if (data.error) {
      throw new Error(data.response);
    }
    commit("LOGOUT_USER");
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const loadCreative = async (context, creativeId) => {
  try {
    const data = await API.loadCreative(creativeId);
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const getComments = async (context, creativeId) => {
  try {
    const data = await API.getComments(creativeId);
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const addComment = async (
  context,
  { creativeId, parentId, message }
) => {
  try {
    let data = null;
    if (!parentId) {
      data = await API.addComment(creativeId, message);
    } else {
      data = await API.addSubComment(creativeId, parentId, message);
    }
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const resolveComment = async (
  context,
  { creativeId, parentId, message, isResolved }
) => {
  try {
    const data = await API.resolveComment(
      creativeId,
      parentId,
      message,
      isResolved
    );
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const deleteComment = async (context, { creativeId, parentId, replyId = "" }) => {
  try {
    const data = await API.deleteComment(creativeId, parentId, replyId);
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};
export const getTemplates = async (
  context,
  { limit, page = 1, search = "" }
) => {
  try {
    const data = await API.getTemplates(limit, page, search);
    if (data.error) {
      throw new Error(data.response);
    }
    // commit("SET_CREATIVES_LIST", data.data.data);
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};
export const listCampaignCreatives = async (
  context,
  { campaignId, filter }
) => {
  try {
    const data = await API.listCampaignCreatives(campaignId, filter);
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};
export const updateCreativePlacement = async (context, details) => {
  try {
    const data = await API.updateCreativePlacement(details);
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const copyCreative = async (context, details) => {
  try {
    const data = await API.copyCreative(details);
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};
export const getPreviewContent = async (context, creative) => {
  try {
    const data = await API.getPreviewContent(creative);
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};
export const downloadTag = async (context, details) => {
  try {
    const data = await API.downloadTag(details);
    if (data.error) {
      throw new Error(data.response);
    } else {
      return data.data ?? data;
    }
  } catch (err) {
    console.log(err);
    throw err;
  }
};
// export const downloadSelectedTags = async (context, details) => {
//   try {
//     const data = await API.downloadSelectedTags(details);
//     if (data.error) {
//       throw new Error(data.response);
//     } else {
//       return data.data;
//     }
//   } catch (err) {
//     console.log(err);
//     throw err;
//   }
// };
export const publishCreative = async (
  context,
  { creativeId, html, duration, content, timedEvents, isResponsive }
) => {
  try {
    const data = await API.publishCreative(creativeId, html, duration, content, timedEvents, isResponsive);
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};
export const downloadPlacement = async (context, { placementId, macros }) => {
  try {
    console.log("downloadPlacement", placementId, macros);
    const data = await API.exportSinglePlacementTag(placementId, macros);
    if (data.error) {
      throw new Error(data.response);
    } else {
      return data.data;
    }
  } catch (err) {
    console.log(err);
    throw err;
  }
};
export const discardDraftChanges = async (context, creativeId) => {
  try {
    const data = await API.discardDraftChanges(creativeId);
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const setReadonly = async ({ commit }, readonly) => {
  commit("SET_READONLY", readonly);
};
export const listCreativeSharedUsers = async (context, creativeId) => {
  try {
    const data = await API.listCreativeSharedUsers(creativeId);
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const forgotPassword = async (context, email) => {
  try {
    const data = await API.forgotPassword(email);
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};
export const setSharedUsers = async (context, { creativeId, userIds }) => {
  try {
    const data = await API.setSharedUsers(creativeId, userIds);
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const passwordReset = async (
  context,
  { token, password, password_confirmation }
) => {
  try {
    const data = await API.passwordReset(
      token,
      password,
      password_confirmation
    );
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const changePassword = async (context, { old_password, password, password_confirmation }) => {
  try {
    const data = await API.changePassword(
      old_password,
      password,
      password_confirmation
    );
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const renameCreative = async (context, details) => {
  try {
    const data = await API.renameCreative(details);
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};
export const getSharedCreatives = async (context, { page = 1, search }) => {
  try {
    const data = await API.getSharedCreatives(page, search);
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};
export const deleteSharedUser = async (context, { creativeId, userId }) => {
  try {
    const data = await API.deleteSharedUser(creativeId, userId);
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};
export const getTrashedCreatives = async (context, { page = 1, search }) => {
  try {
    const data = await API.getTrashedCreatives(page, search);
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};
export const restoreCreative = async (context, { creativeId }) => {
  try {
    const data = await API.restoreCreative(creativeId);
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};
export const deleteCreativePermanently = async (context, { creativeId }) => {
  try {
    const data = await API.deleteCreativePermanently(creativeId);
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};
export const deleteCreative = async (context, { creativeId }) => {
  try {
    const data = await API.deleteCreative(creativeId);
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};
export const getPlacementAnalytics = async (
  context,
  { placementId, startDate, endDate }
) => {
  try {
    const data = await API.getPlacementAnalytics(
      placementId,
      startDate,
      endDate
    );
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};
export const getHourlyBreakDownImpressions = async (
  context,
  { placementId, dateSelected }
) => {
  try {
    const data = await API.getHourlyBreakDownImpressions(
      placementId,
      dateSelected
    );
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};
export const getDailySummary = async (
  context,
  { placementId, pageNo, limit, timezone, startDate }
) => {
  try {
    const data = await API.getDailySummary(
      placementId,
      pageNo,
      limit,
      timezone,
      startDate
    );
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const getCreativeAnalytics = async (
  context,
  { creativeId, startDate, endDate }
) => {
  try {
    const data = await API.getCreativeAnalytics(creativeId, startDate, endDate);
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};
export const getCreativeHourlyBreakDownImpressions = async (
  context,
  { creativeId, dateSelected }
) => {
  try {
    const data = await API.getCreativeHourlyBreakDownImpressions(
      creativeId,
      dateSelected
    );
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};
export const getCreativeDailySummary = async (
  context,
  { creativeId, pageNo, limit, timezone, startDate }
) => {
  try {
    const data = await API.getCreativeDailySummary(
      creativeId,
      pageNo,
      limit,
      timezone,
      startDate
    );
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};
export const getAllPlatforms = async () => {
  try {
    const data = await API.getAllPlatforms();

    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};
export const getAllTemplateTypes = async (
  context,
   withAll  = true
) => {
  try {
    const data = await API.getAllTemplateTypes(withAll);

    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};
export const getAllTemplateCategories = async () => {
  try {
    const data = await API.getAllTemplateCategories();

    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};
export const getTemplateByCategory = async (
  context,
  { categoryId, pageNo = 1, search = "", typeId = "", platformId = "", width = "", height = "", ispaginate = 1 }
) => {
  try {
    const data = await API.getTemplateByCategory(
      categoryId,
      pageNo,
      search,
      typeId,
      platformId,
      width,
      height,
      ispaginate
    );

    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const getPlacementAdtype = async (context, placementId) => {
  try {
    const data = await API.getPlacementAdtype(placementId);
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const getCreativeAssets = async (context, object) => {
  try {
    const data = await API.getCreativeAssets(object.creativeId, object.filetype);
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const deleteCreativeAsset = async (context, assetId) => {
  try {
    const data = await API.deleteCreativeAsset(assetId);
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const detachCreativeAsset = async (context, { id, assetIds}) => {
  try {
    const data = await API.detachCreativeAsset(id, assetIds);
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};


export const updateCreativeAsset = async (context, object) => {
  try {
    const data = await API.updateCreativeAsset(object.assetId, object.data);
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const replaceCreativeAsset = async (context, detail) => {
  try {
    const data = await API.replaceCreativeAsset(detail.oldId, detail.newId);
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const addTimelineEvent = ({ commit }, frame) => {
  commit("ADD_TIMELINE_EVENT", frame);
};

export const deleteTimelineEvent = ({ commit }, index) => {
  commit("DELETE_TIMELINE_EVENT", index);
};

export const exportTemplate = async (context, templateData) => {
  try {
    const data = await API.exportTemplate(templateData);
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

export const getVersionData = async (context, detail) => {
  try {
    const data = await API.getVersionData(detail.id, detail.index);
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};


export const getCreativeVersions = async (context, creativeId) => {
  try {
    const data = await API.getCreativeVersions(creativeId);
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};


// --------------------------------- Analytics Routes --------------------------------- //


export const getCampaignAnalyticsSummary_v2 = async (context, { campaignId, startDate, endDate, timezone }) => {
  try {
    const data = await API.getCampaignAnalyticsSummary_v2(campaignId, startDate, endDate, timezone);
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};
export const getCampaignAnalyticsData_v2 = async (context, { campaignId, startDate, endDate, timezone }) => {
  try {
    const data = await API.getCampaignAnalyticsData_v2(campaignId, startDate, endDate, timezone);
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};
export const getCampaignAnalyticsTypeData = async (context, {type, campaignId,  start, end, timezone, page_size, page, selectedComponentIds, metric, displayTimezone }) => {
  try {
    const data = await API.getCampaignAnalyticsTypeData(type, campaignId, start, end, timezone, page_size, page, selectedComponentIds, metric, displayTimezone);
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const getCreativeAnalyticsTypeData = async (context, { type, creativeId, start = null, end = null, timezone, page_size = 7, page = 1, selectedComponentIds = [], metric, displayTimezone }) => {
  try {
    const data = await API.getCreativeAnalyticsTypeData(type, creativeId, start, end, timezone, page_size, page, selectedComponentIds, metric, displayTimezone);
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const getPlacementAnalyticsTypeData = async (context, { type, placementId, start = null, end = null, timezone, page_size = 7, page = 1, selectedComponentIds = [], metric, displayTimezone }) => {
  try {
    const data = await API.getPlacementAnalyticsTypeData(type, placementId, start, end, timezone, page_size, page, selectedComponentIds, metric, displayTimezone);
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const getCampaignCompareData_v2 = async (context, { campaignId, startDate, endDate, timezone }) => {
  try {
    const data = await API.getCampaignCompareData_v2(campaignId, startDate, endDate, timezone);
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const getCampaignReferralData_v2 = async (context, { campaignId, startDate, endDate, timezone }) => {
  try {
    const data = await API.getCampaignReferralData_v2(campaignId, startDate, endDate, timezone);
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const getCampaignHourlyGraphData_v2 = async (context, { campaign, day, timezone, startTime, endTime }) => {
  try {
    const data = await API.getCampaignHourlyGraphData_v2(campaign, day, timezone, startTime, endTime);
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};
export const getCreativeAnalyticsData_v2 = async (context, { creativeId, startDate, endDate, timezone }) => {
  try {
    const data = await API.getCreativeAnalyticsData_v2(creativeId, startDate, endDate, timezone);
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};
export const getPlacementAnalyticsData_v2 = async (context, { placementId, startDate, endDate, timezone }) => {
  try {
    const data = await API.getPlacementAnalyticsData_v2(placementId, startDate, endDate, timezone);
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};
export const getPlacementReferralData_v2 = async (context, { placementId, startDate, endDate, timezone }) => {
  try {
    const data = await API.getPlacementReferralData_v2(placementId, startDate, endDate, timezone);
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const getPlacementCompareData_v2 = async (context, { placementId, startDate, endDate, timezone }) => {
  try {
    const data = await API.getPlacementCompareData_v2(placementId, startDate, endDate, timezone);
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const getPlacementHourlyGraphData_v2 = async (context, { placement, day, timezone, startTime, endTime }) => {
  try {
    const data = await API.getPlacementHourlyGraphData_v2(placement, day, timezone, startTime, endTime);
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};


export const getPlacementAnalytics_v2 = async (context, { placementId, startDate, endDate, timezone }) => {
  try {
    const data = await API.getPlacementAnalytics_v2(placementId, startDate, endDate, timezone);
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};


export const getCreativeAnalytics_v2 = async (context, { creativeId, startDate, endDate, timezone }) => {
  try {
    const data = await API.getCreativeAnalytics_v2(creativeId, startDate, endDate, timezone);
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const getHourlyCreativeAnalytics_v2 = async (context, { creative, day, timezone, startTime, endTime }) => {
  try {
    const data = await API.getHourlyCreativeAnalytics_v2(creative, day, timezone, startTime, endTime);
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const getCreativeReferralData_v2 = async (context, { creativeId, startDate, endDate, timezone }) => {
  try {
    const data = await API.getCreativeReferralData_v2(creativeId, startDate, endDate, timezone);
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const getCreativeCompareData_v2 = async (context, { creativeId, startDate, endDate, timezone }) => {
  try {
    const data = await API.getCreativeCompareData_v2(creativeId, startDate, endDate, timezone);
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const getCreativeHourlyGraphData_v2 = async (context, { creative, day, timezone, startTime, endTime }) => {
  try {
    const data = await API.getCreativeHourlyGraphData_v2(creative, day, timezone, startTime, endTime);
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const exportHourlyAnalytics = async (context, { uniqueId, tzOffset,day, startTime, endTime ,type, filters }) => {
  try {
    const data = await API.exportHourlyAnalytics(uniqueId,tzOffset, day, startTime, endTime , type, filters);
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};
export const exportFullEventList = async (context, { uniqueId, tz, startDateTime, endDateTime ,type ,filters}) => {
  try {
    const data = await API.exportFullEventList(uniqueId, tz, startDateTime, endDateTime , type, filters);
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const exportReferralData = async (context, { uniqueId, tzOffset, startDateTime, endDateTime, type, metric }) => {
  try {
    const data = await API.exportReferralData(uniqueId, tzOffset, startDateTime, endDateTime, type, metric);
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};
export const exportHourlyImpressionData = async (context, { uniqueId, tzOffset, startDateTime, endDateTime, type }) => {
  try {
    const data = await API.exportHourlyImpressionData(uniqueId, tzOffset, startDateTime, endDateTime, type);
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const exportFormSubmissions = async (context, { uniqueId, tzOffset, startDateTime, endDateTime, type }) => {
  try {
    const data = await API.exportFormSubmissions(uniqueId, tzOffset, startDateTime, endDateTime, type);
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const getConversationFlowSummary = async (context, { creativeId, tzOffset, startDateTime, endDateTime }) => {
  try {
    const data = await API.getConversationFlowSummary(creativeId, tzOffset, startDateTime, endDateTime);
    if (data.error) {
      throw new Error(data.message || data.response || 'Failed to load Conversation Flow summary');
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const getPlacementConversationFlowSummary = async (context, { placementId, tzOffset, startDateTime, endDateTime }) => {
  try {
    const data = await API.getPlacementConversationFlowSummary(placementId, tzOffset, startDateTime, endDateTime);
    if (data.error) {
      throw new Error(data.message || data.response || 'Failed to load Conversation Flow summary');
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const getCampaignConversationFlowSummary = async (context, { campaignId, tzOffset, startDateTime, endDateTime }) => {
  try {
    const data = await API.getCampaignConversationFlowSummary(campaignId, tzOffset, startDateTime, endDateTime);
    if (data.error) {
      throw new Error(data.message || data.response || 'Failed to load Conversation Flow summary');
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const getHourlyPlacementAnalytics_v2 = async (context, { placement, day, timezone, startTime, endTime }) => {
  try {
    const data = await API.getHourlyPlacementAnalytics_v2(placement, day, timezone, startTime, endTime);
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};
export const getHourlyCampaignAnalytics_v2 = async (context, { campaign, day, timezone, startTime, endTime }) => {
  try {
    const data = await API.getHourlyCampaignAnalytics_v2(campaign, day, timezone, startTime, endTime);
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const getCampaignCreatives_v2 = async (context, { campaignId, startDate, endDate, page, search, adType, timezone }) => {
  try {
    const data = await API.getCampaignCreatives_v2(campaignId, startDate, endDate, page, search, adType, timezone);
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const setMediaTranscoding = (context, { assetID,  accessId,  assetFolderId, brandKitId}) => {
  try {
    console.log("AssetId--> ", assetID);
    API.setMediaTranscoding(assetID, accessId, assetFolderId, brandKitId);
  } catch (err) {
    console.log(err);
    throw err;
  }
}

export const getImageOptimizationToken = async (context, { key, canvasWidth, canvasHeight, eventName, domain, userId, broadcastChannel }) => {
  try {
    const data = await API.getImageOptimizationToken(key, canvasWidth, canvasHeight, eventName, domain, userId, broadcastChannel);
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

export const generateJwtToken = async (context, { key, canvasWidth, canvasHeight, eventName, domain, userId, broadcastChannel, url }) => {
  try {
    const data = await API.generateJwtToken(key, canvasWidth, canvasHeight, eventName, domain, userId, broadcastChannel, url);
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

export const storeCreativeExitUrl = async (context, { creativeId, exitUrls }) => {
  try {
    const data = await API.storeCreativeExitUrl(creativeId, exitUrls);
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  }
  catch (err) {
    console.log(err);
    throw err;
  }
}

export const setPrimaryVideo = async (context, { asset, creativeId, isPrimary }) => {
  try {
    const data = await API.setPrimaryVideo(asset, creativeId, isPrimary);
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

export const addTimedEvent = async ({ commit }, { componentId, timedEvent }) => {
  try {
    commit("ADD_TIMED_EVENT", { componentId, timedEvent });
  } catch (err) {
    console.log(err);
    throw err;
  }
}

export const sendPreviewLink = async (context, { creativeId, emails, url, name }) => {
  try {
    const data = await API.sendPreviewLink(creativeId, emails, url, name);
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}


export const deleteTimedEvent = async ({ commit }, componentId) => {
  try {
    commit("DELETE_TIMED_EVENT", componentId);
  } catch (err) {
    console.log(err);
    throw err;
  }
}

export const generateAdTags = async (context, { creativeId, placementId, macros }) => {
  try {
    const data = await API.generateAdTags(creativeId, placementId, macros);
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};  

export const createAssetFolder = async (context, { parentId, type, name }) => {
  try {
    const data = await API.createAssetFolder(parentId, type, name);
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

export const setTimedEvent = async ({ commit }, data) => {
  try {
    commit("SET_TIMED_EVENT", data);
  } catch (err) {
    console.log(err);
    throw err;
  }
}

export const updateAssetFolder = async (context, object) => {
  try {
    const data = await API.updateAssetFolder(object.assetFolderId, object.data);
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

export const deleteAssetFolder = async (context, folderId) => {
  try {
    const data = await API.deleteAssetFolder(folderId);
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

export const attachAssetToFolder = async (context, { assetId, folderId, creativeId }) => {
  try {

    const data = await API.attachAssetToFolder(assetId, folderId, creativeId);
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const getNotifications = async (context, params = {}) => {
  try {
    const data = await API.getNotifications(params);
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

export const getUnreadNotificationsCount = async (context) => {
  try {
    const data = await API.getUnreadNotificationsCount();
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}
export const markAllNotificationAsRead = async (context) => {
  try {
    const data = await API.markAllNotificationAsRead();
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}
export const markNotificationAsRead = async (context, notificationId) => {
  try {
    const data = await API.markNotificationAsRead(notificationId);
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}
export const deleteNotification = async (context, notificationId) => {
  try {
    const data = await API.deleteNotification(notificationId);
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}
export const clearAllNotifications = async (context) => {
  try {
    const data = await API.clearAllNotifications();
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}
export const getRecentSearches = async (context) => {
  try {
    const data = await API.getRecentSearches();
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}
export const globalSearch = async (context,query) => {
  try {
    const data = await API.globalSearch(query);
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}
export const trackSearch = async (context,result) => {
  try {
    const data = await API.trackSearch(result);
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}
export const clearCurrentHistory = async (context,result) => {
  try {
    const data = await API.clearCurrentHistory(result);
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}
export const clearAllHistory = async (context) => {
  try {
    const data = await API.clearAllHistory();
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

export const fetchBannerDetails = async (context) => {
  try {
    const data = await API.fetchBannerDetails();
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const getAdctvWidgets = async (context, creativeId) => {
  try {
    const data = await API.getAdctvWidgets(creativeId);
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};



// --------------------------------- V2 API --------------------------------- //
export const loadCreativeV2 = async (context, creativeId) => {
  try {
    const data = await API.loadCreativeV2(creativeId);
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const fetchWidgetCategories = async (context) => {
  try {
    const data = await API.fetchWidgetCategories();
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  }
  catch (err) {
    console.log(err);
    throw err;
  }
}

export const getLayouts = async (context) => {
  try {
    const data = await API.getLayouts();
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  }
  catch (err) {
    console.log(err);
    throw err;
  }
}
export const getLayoutData = async (context, layoutId) => {
  try {
    const data = await API.getLayoutData(layoutId);
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  }
  catch (err) {
    console.log(err);
    throw err;
  }
}
export const deleteLayout = async (context, layoutId) => {
  try {
    const data = await API.deleteLayout(layoutId);
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  }
  catch (err) {
    console.log(err);
    throw err;
  }
}

export const getLayoutByCategory = async (context, category) => {
  try {
    const data = await API.getLayoutByCategory(category);
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  }
  catch (err) {
    console.log(err);
    throw err;
  }
}

export const getWidgetDefaultAssets = async (tagName) => {
  try {
    const data = await API.getWidgetDefaultAssets(tagName);
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

export const generateCreativeThumbnail = async (context, creativeId) => {
  try {
    const data = await API.generateCreativeThumbnail(creativeId);
    if (data.error) {
      throw new Error(data.response);
    }
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

export const setCreativeRenderingStatus = ({ commit }, payload) => {
  commit("SET_CREATIVE_RENDERING_STATUS", payload);
};

